import { StatusCategory } from '@cycle-app/graphql-codegen';

export const categoryKeys: Record<StatusCategory, 'notStarted' | 'started' | 'completed' | 'canceled'> = {
  [StatusCategory.NotStarted]: 'notStarted',
  [StatusCategory.Started]: 'started',
  [StatusCategory.Completed]: 'completed',
  [StatusCategory.Canceled]: 'canceled',
};
